import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';


function alphaSliders(sliderArray) {
    var labels = {
        "color": ['M', 'L', 'K', 'J', 'I', 'H', 'G', 'F', 'E', 'D'],
        "clarity": ['I1', 'SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF'],
        "cut": ['FR', 'GD', 'VG', 'EX', 'ID'],
        "polish": ['FR', 'GD', 'VG', 'EX'],
        "symmetry": ['FR', 'GD', 'VG', 'EX'],
        "fluorescence": ['None', 'VS', 'S', 'M', 'Stg', 'VStg'],
    };


    for (var i = 0; i < sliderArray.length; i++) {
        let sliderName = sliderArray[i];
        let selector = document.getElementById(sliderName + '-slider');
        if (selector) {
            let startFrom = document.querySelector("input[name='" + sliderName + "_from']").value;
            let startTo = document.querySelector("input[name='" + sliderName + "_to']").value;
            noUiSlider.create(selector, {
                connect: true,
                behaviour: 'tap',
                start: [startFrom, startTo],
                step: 1,
                range: {
                    'min': [0],
                    'max': [labels[sliderName].length - 1]
                },
                pips: {
                    mode: 'steps',
                    filter: function(value, type) {
                        return type === 0 ? -1 : 1;
                    },
                    format: {
                        to: function(value) {
                            return labels[sliderName][value];
                        }
                    }
                }
            });

            selector.noUiSlider.on('change', function() {
                document.querySelector("input[name='" + sliderName + "_from']").value = Math.ceil(this.get(true)[0]);
                document.querySelector("input[name='" + sliderName + "_to']").value = Math.ceil(this.get(true)[1]);
            });
        }


    }
}

function numericSliders(sliderArray) {


    for (var i = 0; i < sliderArray.length; i++) {
        // debugger
        let sliderName = sliderArray[i];
        let selector = document.getElementById(sliderName + '-slider');

        let min = document.querySelector("input[name='" + sliderName + "_from']").getAttribute('min');
        let max = document.querySelector("input[name='" + sliderName + "_to']").getAttribute('max');

        // console.log(min, max)
        let handle1 = document.querySelector("input[name='" + sliderName + "_from']");
        let handle2 = document.querySelector("input[name='" + sliderName + "_to']");

        let handleArray = [handle1, handle2]

        noUiSlider.create(selector, {
            start: [handle1.value, handle2.value],
            connect: true,
            tooltips: [
                false, // no tooltip
                // wNumb({decimals: 1}), // tooltip with custom formatting
                false // tooltip with default formatting
            ],
            range: {
                'min': parseFloat(min),
                'max': parseFloat(max),
            }
        });

        selector.noUiSlider.on('update', function(values, handle) {
            handleArray[handle].value = values[handle];
        });
        document.querySelector("input[name='" + sliderName + "_from']").addEventListener('change', function() {
            selector.noUiSlider.set([this.value, null]);
        });
        document.querySelector("input[name='" + sliderName + "_to']").addEventListener('change', function() {
            selector.noUiSlider.set([null, this.value]);
        });

    }
}
// test commit 
function encodeURL(object) {

    let parameters = [];

    for (let property in object) {
        if (object.hasOwnProperty(property)) {
            parameters.push(encodeURI(property + '=' + object[property]));
        }
    }
    return parameters.join('&')

}


function encodeURLNew(object) {

    let parameters = {};

    for (let property in object) {
        if (object.hasOwnProperty(property)) {

            if (Array.isArray(object[property])) {
                parameters[property] = object[property].join(',');
            } else {
                parameters[property] = object[property];
            }

            
        }
    }
    return parameters

}



export { alphaSliders, encodeURLNew, numericSliders, encodeURL };

// alphaSliders(['color', 'clarity', 'cut', 'polish', 'symmetry', 'fluorescence']);

//   numericSliders(['depth', 'table', 'lw']);